import React from 'react';

interface OptionGroupProps {
  label?: string;
  optionList: { value: string; label: string }[];
}

export const OptionGroup = ({ label, optionList }: OptionGroupProps) => {
  const renderedOptions = optionList.map((option) => (
    <option
      key={option.value}
      className="c-select__option"
      value={option.value}
    >
      {option.label}
    </option>
  ));

  return label !== undefined ? (
    <optgroup label={label}>{renderedOptions}</optgroup>
  ) : (
    <>{renderedOptions}</>
  );
};

export default OptionGroup;
